module.exports = __webpack_public_path__ + "static/media/Etiquetas2.3ffc89e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancEtiquetas/Etiquetas2.png
// module id = 2255
// module chunks = 0